import { computed } from "nanostores";
import { requestGet } from "../utils/request.ts";
import { $sessionVersion, getSessionVersion } from "./user_info.ts";
import { createRefreshResource } from "../utils/refresh_resource.ts";

export type OSSInfo = {
    id: number;
    oss_id: number;
    oss_name: string;
    oss_bucket: string;
    oss_endpoint: string;
    paid: boolean;
    vip_expire?: number;
};

export type GetOSSListResponse = {
    osses: OSSInfo[];
};

/* ==== Stores ==== */
export const ossResource = createRefreshResource(async signal => {
    const resp = await requestGet<GetOSSListResponse>("/v2/oss", {}, signal);
    return resp.osses ?? [];
}, [] as OSSInfo[], getSessionVersion);
export const $ossList = computed(ossResource.$state, state => state.data);
export const $ossListLoaded = computed(ossResource.$state, state => state.loaded);

/* ==== Actions ==== */
export const updateOSSInfo = ossResource.refresh;
export const invalidateOSSInfo = ossResource.invalidate;
$sessionVersion.listen(() => ossResource.reset());
